<template>
  <v-app id="inspire">
    <v-content>
      <v-container grid-list-xl>
        <v-layout wrap>
          <v-flex xs12>
            <v-card class="mb-2">
              <v-toolbar flat transparent>
                <v-btn icon class="hidden-xs-only" to="/">
                  <v-icon>arrow_back</v-icon>
                </v-btn>
                <v-toolbar-title>Future Carbon</v-toolbar-title>
                <v-spacer />
                <v-btn color="green darken-2" round dark @click="dialog = true">Calculate</v-btn>
              </v-toolbar>
            </v-card>
          </v-flex>
          <v-flex xs12>
            <v-card>
              <v-card-text>
                <v-layout wrap>
                  <v-flex xs12 sm6>
                    <div class="mb-2">
                      Start Coordinate: <strong>{{ startCoord }}</strong>
                    </div>
                    <div class="mb-2">
                      End Coordinate: <strong>{{ endCoord }}</strong>
                    </div>
                    <div class="mb-2">
                      Total Length: <strong>{{ totalLength }} m</strong>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <div v-for="row in rows" :key="row.id">
                      <div class="mb-2">
                        {{ row.name }}:
                        <strong>{{ row.value }} - {{ row.label }}</strong>
                      </div>
                    </div>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>

        <v-layout v-if="datas.length > 0">
          <v-item-group
            v-model="window"
            class="shrink mr-4 mt-1"
            mandatory
            tag="v-flex"
          >
            <v-item v-for="win in windows" :key="win.id">
              <div slot-scope="{ active, toggle }">
                <v-btn
                  flat
                  block
                  round
                  :input-value="active"
                  @click="toggle"
                  color="green darken-2"
                >
                  {{ win.name }}
                </v-btn>
              </div>
            </v-item>
          </v-item-group>

          <v-flex>
            <v-window v-model="window" vertical>
              <v-window-item :key="1">
                <v-layout wrap v-if="datas.length > 0">
                  <v-flex xs12>
                    <v-card class="elevation-1">
                      <v-tabs
                        v-model="active"
                        color="green darken-2"
                        dark
                        centered
                        slider-color="yellow"
                      >
                        <v-tab
                          v-for="(data, index) in datas"
                          :key="index"
                          ripple
                        >
                          {{ data.name }}
                        </v-tab>
                        <v-tab-item v-for="(data, index) in datas" :key="index">
                          <v-card flat>
                            <v-card-text>
                              <stack-chart
                                :items="data.mortality0"
                                :categories="categories"
                                title="Mortality 0"
                                chart-type="area"
                                :tooltip-split="true"
                                x-axis-title="x Axis"
                                y-axis-title="y Axis"
                              />
                            </v-card-text>
                          </v-card>
                          <v-card flat>
                            <v-card-text>
                              <stack-chart
                                :items="data.mortality15"
                                :categories="categories"
                                title="Mortality 15"
                                chart-type="area"
                                :tooltip-split="true"
                                x-axis-title="x Axis"
                                y-axis-title="y Axis"
                              />
                            </v-card-text>
                          </v-card>
                          <v-card flat>
                            <v-card-text>
                              <stack-chart
                                :items="data.mortality30"
                                :categories="categories"
                                title="Mortality 30"
                                chart-type="area"
                                :tooltip-split="true"
                                x-axis-title="x Axis"
                                y-axis-title="y Axis"
                              />
                            </v-card-text>
                          </v-card>
                          <v-card flat>
                            <v-card-text>
                              <stack-chart
                                :items="data.mortality50"
                                :categories="categories"
                                title="Mortality 50"
                                chart-type="area"
                                :tooltip-split="true"
                                x-axis-title="x Axis"
                                y-axis-title="y Axis"
                              />
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                      </v-tabs>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-window-item>

              <v-window-item :key="2">
                <v-card class="elevation-1 mt-3">
                  <v-tabs
                    v-model="active2"
                    color="green darken-2"
                    dark
                    centered
                    slider-color="yellow"
                  >
                    <v-tab
                      v-for="(data, index) in datasEconomic"
                      :key="index"
                      ripple
                    >
                      {{ data.name }}
                    </v-tab>
                    <v-tab-item
                      v-for="(data, index) in datasEconomic"
                      :key="index"
                    >
                      <v-card flat>
                        <v-card-text>
                          <stack-chart
                            :items="data.economic"
                            :categories="categoriesEconomic"
                            :tooltip-split="true"
                            title="Economics"
                            chart-type="area"
                            x-axis-title="x Axis"
                            y-axis-title="y Axis"
                          />
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                  </v-tabs>
                </v-card>
              </v-window-item>
            </v-window>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

    <v-dialog v-model="dialog" max-width="35%">
      <v-card>
        <v-card-title class="headline">Calculate</v-card-title>
        <v-card-text>
          <div class="mb-2">
            Start Coordinate: <strong>{{ startCoord }}</strong>
          </div>
          <div class="mb-2">
            End Coordinate: <strong>{{ endCoord }}</strong>
          </div>
          <div>
            Total Length: <strong>{{ totalLength }} m</strong>
          </div>
        </v-card-text>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <v-layout row wrap align-center>
                <v-flex xs6 sm3>
                  <v-subheader>Rows</v-subheader>
                </v-flex>
                <v-flex xs6 sm9>
                  <v-select
                    v-model="rowCount"
                    :items="count"
                    label="Select..."
                    @change="selectRow()"
                    :rules="rowsRules"
                    required
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-divider class="mb-3"></v-divider>
              <v-layout
                v-for="(row, index) in rows"
                :key="index"
                row
                wrap
                align-center
              >
                <v-flex xs6 sm3 class="py-0">
                  <v-subheader>{{ row.name }}</v-subheader>
                </v-flex>
                <v-flex xs6 sm9>
                  <v-select
                    v-model="row.specie"
                    :items="species"
                    label="Species..."
                    return-object
                    text-value="value"
                    item-text="label"
                    :rules="rowRules"
                    @change="changeSpecie(row)"
                    required
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="green darken-2" flat round @click="dialog = false">Close</v-btn>
          <v-btn color="green darken-2" flat round @click="calc()">Calculate</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="loading" persistent width="300">
      <v-card color="green darken-2" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import axios from "axios";
import generic from "../mixins/generic";
import StackChart from "./stack_chart";

export default {
  name: "Row",
  components: {
    StackChart
  },
  mixins: [generic],
  data() {
    return {
      windows: [{ name: "Future Carbon", id: 1 }, { name: "Economics", id: 2 }],
      window: 0,
      active: null,
      active2: null,
      totalLength: this.$route.params.total,
      startCoord: this.$route.params.start,
      endCoord: this.$route.params.end,
      drawer: null,
      valid: true,
      rowRules: [v => !!v || "Row is required"],
      rowsRules: [v => !!v || "Rows is required"],
      count: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      species: [
        { label: "Caragana Spacing", value: "CA" },
        { label: "White Spruce Spacing", value: "WS" },
        { label: "Scots Pine Spacing", value: "SP" },
        { label: "Green Ash", value: "GA" },
        { label: "Hybrid Poplar", value: "HP" },
        { label: "Manitoba Maple", value: "MM" }
      ],
      rowCount: null,
      rows: [],
      hidden: false,
      items: [],
      loading: false,
      dialog: true,
      categories: [],
      datas: [],
      itemsBiomass: [],
      itemsDom: [],
      datasEconomic: [],
      categoriesEconomic: []
    };
  },
  methods: {
    selectRow() {
      this.rows = [];

      for (var i = 1; i <= this.rowCount; i++) {
        var obj = {};
        obj.name = "Row " + i;
        obj.index = i;
        obj.value = null;
        obj.label = null;
        this.rows.push(obj);
      }
    },
    changeSpecie(item) {
      item.value = item.specie.value;
      item.label = item.specie.label;
    },
    calc() {
      var vm = this;

      if (vm.$refs.form.validate()) {
        vm.items = [];
        let url = `${process.env.API_ROOT}/carbon/future/${vm.startCoord}/${vm.endCoord}/${vm.totalLength}`;
        let urlEconomic = `${process.env.API_ROOT}/carbon/economics/${vm.startCoord}/${vm.endCoord}/${vm.totalLength}`;
        vm.hidden = true;

        if (vm.rows.length > 0) {
          let body = [];
          vm.loading = true;

          vm.rows.forEach(function(item) {
            var obj = {
              index: item.index,
              value: item.value
            };
            body.push(obj);
          });

          axios
            .post(url, body)
            .then(response => {
              vm.parseArray(response.data.list);
              vm.loading = false;
              vm.dialog = false;
            })
            .catch(err => {
              vm.loading = false;
            });

          axios
            .post(urlEconomic, body)
            .then(response => {
              vm.parseArrayEconomic(response.data.list);
            })
            .catch(err => {});
        }
      }
    },
    parseArrayEconomic(array) {
      let datas = [];
      let categories = [];

      array.forEach(function(child, index) {
        if (child.list) {
          let data = {};
          data.name = `Species: ${child.speciesTO.value}`;

          let biomValue = [];
          let domValue = [];

          child.list.forEach(function(array, arrayIndex) {
            if (array.biomValue) biomValue.push(array.biomValue);
            if (array.domValue) domValue.push(array.domValue);

            if (index == 0) {
              categories.push(array.year);
            }
          });

          data.economic = [
            { name: "Dom:", data: domValue },
            { name: "Biomass:", data: biomValue }
          ];

          datas.push(data);
        }
      });
      // console.log('categories', categories)
      // console.log('datas', datas)
      this.datasEconomic = datas;
      this.categoriesEconomic = categories;
    },
    parseArray(array) {
      let datas = [];
      let categories = [];

      array.forEach(function(child, index) {
        if (child.list) {
          let data = {};
          data.name = `Species: ${child.speciesTO.value}`;

          let biom0Mort = [];
          let biom15Mort = [];
          let biom30Mort = [];
          let biom50Mort = [];
          let dom0Mort = [];
          let dom15Mort = [];
          let dom30Mort = [];
          let dom50Mort = [];

          child.list.forEach(function(array, arrayIndex) {
            if (array.biom0Mort) biom0Mort.push(array.biom0Mort);
            if (array.biom15Mort) biom15Mort.push(array.biom15Mort);
            if (array.biom30Mort) biom30Mort.push(array.biom30Mort);
            if (array.biom50Mort) biom50Mort.push(array.biom50Mort);
            if (array.dom0Mort) dom0Mort.push(array.dom0Mort);
            if (array.dom15Mort) dom15Mort.push(array.dom15Mort);
            if (array.dom30Mort) dom30Mort.push(array.dom30Mort);
            if (array.dom50Mort) dom50Mort.push(array.dom50Mort);

            if (index == 0) {
              categories.push(array.year);
            }
          });

          data.mortality0 = [
            { name: "Dom", data: dom0Mort },
            { name: "Biomass", data: biom0Mort }
          ];

          data.mortality15 = [
            { name: "Dom", data: dom15Mort },
            { name: "Biomass", data: biom15Mort }
          ];

          data.mortality30 = [
            { name: "Dom", data: dom30Mort },
            { name: "Biomass", data: biom30Mort }
          ];

          data.mortality50 = [
            { name: "Dom", data: dom50Mort },
            { name: "Biomass", data: biom50Mort }
          ];

          datas.push(data);
        }
      });

      this.datas = datas;
      this.categories = categories;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/carbon_future.vue